import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function OneDriveCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const accessToken = searchParams.get('accessToken');
    const refreshToken = searchParams.get('refreshToken');
    const expiresOn = searchParams.get('expiresOn');
    const error = searchParams.get('error');

    // BroadcastChannel funciona aunque window.opener sea null por COOP de Microsoft
    const channel = new BroadcastChannel('onedrive-auth');

    if (error) {
      channel.postMessage({ type: 'onedrive-auth-error', error });
    } else if (accessToken) {
      channel.postMessage({ type: 'onedrive-auth-success', accessToken, refreshToken, expiresOn });
    }

    channel.close();
    window.close();
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <p>Cerrando ventana...</p>
    </div>
  );
}
